/**
 * @generated SignedSource<<272051daad6b75a257adaac16e7bf5b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Filter$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AssigneePicker">;
  readonly " $fragmentType": "Filter";
};
export type Filter$key = {
  readonly " $data"?: Filter$data;
  readonly " $fragmentSpreads": FragmentRefs<"Filter">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scope"
    }
  ],
  "kind": "Fragment",
  "name": "Filter",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "scope"
        }
      ],
      "kind": "FragmentSpread",
      "name": "AssigneePicker"
    }
  ],
  "type": "Query"
};

(node as any).hash = "1378140462e9f360bd2a0363cd609048";

export default node;
